import React, { useState, useEffect } from 'react';
import { getProviders } from '../pages/Providers';
import { useSelector } from 'react-redux';
import { sorts } from '../utils';
import Select from './form/Select';

const AdminProviderSelect = ({
    value = '',
    showPublishers = false,
    onChange = () => {},
    ...restProps
}) => {
    const isAdmin = useSelector((state) => state.session.isAdmin);

    const [providers, setProviders] = useState([]);

    useEffect(() => {
        if (isAdmin) {
            getProviders().then(({ results }) => setProviders(results));
        }
    }, [isAdmin]);

    const handleChange = (id, value) => {
        const _v = Number(value);
        const v = providers.find((p) => p.id === _v);
        return onChange(id, v);
    };

    if (!isAdmin) return null;

    return (
        <Select {...restProps} value={value} onChange={handleChange}>
            {providers
                .sort((a, b) => sorts.asc(a.name, b.name))
                .map((p) => (
                    <option key={p.id} value={p.id}>
                        {p.name} {showPublishers && !!p.publishers?.length && `(${p.publishers.join(', ')})`}
                    </option>
                ))}
        </Select>
    );
};

export default AdminProviderSelect;
